<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyActionListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyActionListing from "@/views/pages/admin/propertyAction/propertyActionListing";

export default {
    page: {
        title: i18n.t("module.propertyAction"),
    },
    components: { Layout, PageHeader, PropertyActionListing },
    data() {
        return {
            title: i18n.t("module.propertyAction"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("module.propertyAction"),
                    active: true,
                },
            ],
        };
    },
}
</script>
